import { render, staticRenderFns } from "./UrlKeywordTable.vue?vue&type=template&id=3936f9d2&scoped=true"
import script from "./UrlKeywordTable.vue?vue&type=script&lang=js"
export * from "./UrlKeywordTable.vue?vue&type=script&lang=js"
import style0 from "./UrlKeywordTable.vue?vue&type=style&index=0&id=3936f9d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936f9d2",
  null
  
)

export default component.exports